// extracted by mini-css-extract-plugin
export default {"container":"Separator_container__v98AA","horizontal":"Separator_horizontal__YDSs1","vertical":"Separator_vertical__hXwgz"};